export default "__VITE_ASSET__DSqkPJ6H__"